import React from 'react';
import '../styles/Modals.css';

function TeamModal({ 
  showTeamModal, 
  setShowTeamModal, 
  newTeamName, 
  setNewTeamName, 
  handleCreateTeam 
}) {
  if (!showTeamModal) return null;

  return (
    <div className="modal-overlay" onClick={() => setShowTeamModal(false)}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Create New Team</h2>
        
        {/* Warning Banner */}
        <div className="team-creation-warning">
          <span className="warning-icon">⚠️</span>
          <p>
            <strong>Important:</strong> Teams cannot be deleted once created. 
            You can rename teams and move members between teams at any time.
          </p>
        </div>
        
        <form onSubmit={handleCreateTeam}>
          <div className="form-group">
            <label>Team Name</label>
            <input
              type="text"
              value={newTeamName}
              onChange={(e) => setNewTeamName(e.target.value)}
              placeholder="e.g., Engineering, Sales, Marketing"
              required
            />
          </div>
          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={() => setShowTeamModal(false)}>
              Cancel
            </button>
            <button type="submit" className="btn-create">
              Create Team
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export { TeamModal };